import React from 'react';

import { Helmet } from '@sm/webassets';

import JumboHeader from './components/JumboHeader';
import AppsGrid from './components/AppsGrid';
import AppDirNavHeader from '../../components/AppDirNavHeader';
import AppDirectoryBasePage from '../AppDirectoryBasePage';

const Home = () => {
  return (
    <div data-testid="Home__AppsDirectory">
      <AppDirectoryBasePage
        id="App Directory - Home"
        header={
          <>
            <AppDirNavHeader />
            <JumboHeader />
          </>
        }
      >
        <Helmet>
          <title>SurveyMonkey App Directory &amp; Integrations</title>
          <meta
            name="description"
            content="Integrate with over 100+ SurveyMonkey apps and plug-ins to get more done"
          />
        </Helmet>
        <AppsGrid gridOption="FEATURED" />
        <div className="wds-m-t-4">
          <AppsGrid gridOption="MOST_POPULAR" />
        </div>
        <div className="wds-m-t-4">
          <AppsGrid gridOption="RECENTLY_ADDED" />
        </div>
      </AppDirectoryBasePage>
    </div>
  );
};

export default Home;
